"use strict";

exports.__esModule = true;
exports.DataItemValueHeader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Utils = require("../../../Utils");
var _Core = require("../../Core");
var _common = require("../common");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a header for DataItemValue.
 */
var DataItemValueHeader = exports.DataItemValueHeader = /*#__PURE__*/function (_Component) {
  function DataItemValueHeader() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DataItemValueHeader, _Component);
  var _proto = DataItemValueHeader.prototype;
  _proto.render = function render() {
    var dataItemName = this.props.dataItemName;
    return /*#__PURE__*/_react["default"].createElement(_Core.Heading, {
      level: 4,
      ellipsize: true,
      style: Object.assign({}, (0, _common.getWidgetCSSProps)(this.props), {
        lineHeight: (this.props.height || 30) + "px",
        flex: 1
      })
    }, (0, _Utils.humanizeString)(dataItemName));
  };
  return DataItemValueHeader;
}(_react.Component);